class NewsletterBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.type == 'default') {
      this.form = this.querySelector("form");
      this.countrySelector = this.querySelector(".country-select");
      
      if (this.countrySelector) {
        if (this.countrySelector.value != "") {
          this.updateNewsletterTags();
        }
        this.countrySelector.addEventListener("change", this.updateNewsletterTags.bind(this));
        this.form.addEventListener("submit", this.updateNewsletterTags.bind(this));
        
      }
    } else {
    this.formHasInfo = false;
    this.klaviyoId = this.dataset.klaviyoId;
    this.backgroundImage = this.querySelector(".newsletter-banner__picture");
    this.heading = this.querySelector(".newsletter-banner_heading");
    this.subheading = this.querySelector(".newsletter-banner_subheading");
    this.formContainer = this.querySelector(".newsletter-banner__form");
    this.klaviyoContainer = this.querySelector(
      ".newsletter-klaviyo__container"
    );
    this.klaviyoMutationConfig = {
      attributes: true,
      childList: true,
      subtree: true,
    };
    this.klaviyoSubmitButtonClasses = this.dataset.submitButtonClass.split(" ");
    this.loadingOverlay = this.querySelector(".loading-overlay");
    this.formButtons = this.querySelectorAll("button");
    this.aboveContent = this.querySelector(".newsletter-banner__above-content");
    this.belowContent = this.querySelector(".newsletter-banner__below-content");
    this.errorContent = this.querySelector(".newsletter-banner__error-content");
    this.translations = {
      email: this.dataset.emailTranslation,
      phone: this.dataset.phoneTranslation,
      countries: this.dataset.countriesTranslation,
    };
    this.caret = this.dataset.downwardsCaretIcon;
    this.caretParser = new DOMParser();
    this.caretDoc = this.caretParser.parseFromString(this.caret, "text/html");
    this.caretHTML = this.caretDoc.body.firstChild;
    this.klaviyoMutationObserver = new MutationObserver(
      (mutationList, observer) => {
        // Remove duplicate form containers injected by Klaviyo when facets.js
        // calls history.pushState() during sort/filter. Klaviyo interprets the
        // URL change as a page navigation and re-mounts its embed form, appending
        // a new unstyled child div to the .klaviyo-form element each time.
        for (const mutation of mutationList) {
          if (
            mutation.type === 'childList' &&
            mutation.addedNodes.length > 0 &&
            mutation.target.classList &&
            mutation.target.classList.contains('klaviyo-form')
          ) {
            const firstContainer = mutation.target.querySelector(':scope > .klaviyo-child-container');
            if (firstContainer) {
              Array.from(mutation.target.children).forEach(child => {
                if (child !== firstContainer) child.remove();
              });
            }
            break;
          }
        }

        let classChange = mutationList.find(
          (mutation) =>
            mutation.target.classList.contains("kl-private-reset-css-Xuajs1") ||
            mutation.target.classList.contains("needsclick")
        );
        let childListChange = mutationList.find(
          (mutation) =>
            mutation.target.classList.contains(
              "klaviyo-phone-input-grand-parent"
            ) &&
            mutation.type == "childList" &&
            mutation.removedNodes.length > 0
        );
        let formRemovedChange = mutationList.find((mutation) =>
          mutation.target.classList.contains("klaviyo-child-container")
        );
        if (
          typeof classChange !== "undefined" ||
          typeof childListChange !== "undefined"
        ) {
          this.resetStylesAndClasses(this.klaviyoForm);
          this.addKlaviyoClasses();
        }
      }
    );

    // Disconnect the observer when the page is navigating away to prevent
    // Klaviyo's teardown re-renders from triggering resetStylesAndClasses()
    // and causing a brief unstyled flash of the newsletter form (AV-333).
    window.addEventListener('pagehide', () => {
      this.klaviyoMutationObserver.disconnect();
    });

    window.addEventListener("klaviyoForms", function (e) {
      const newsletterBanner = document.querySelector("newsletter-banner");
      const klaviyoID = newsletterBanner.dataset.klaviyoId;
      if (e.detail.formId === klaviyoID) {
        if (typeof e.detail.metaData !== "undefined") {
          this.formHasInfo = true;
        }
        switch (e.detail.type) {
          case "embedOpen":
            let klaviyoEmbedEvent = new CustomEvent("klaviyoEmbedOpen");
            newsletterBanner.dispatchEvent(klaviyoEmbedEvent);
            break;
          case "viewedStep":
            let klaviyoViewedStepEvent = new CustomEvent("klaviyoViewedStep");

            newsletterBanner.dispatchEvent(klaviyoViewedStepEvent);
            break;
          case "stepSubmit":
            let klaviyoStepSubmitEvent = new CustomEvent("klaviyoStepSubmit", {
              detail: e,
            });

            newsletterBanner.dispatchEvent(klaviyoStepSubmitEvent);
            break;
          case "submit":
            let klaviyoSubmitEvent = new CustomEvent("klaviyoSubmit", {
              detail: e,
            });
            newsletterBanner.dispatchEvent(klaviyoSubmitEvent);
            break;
          case "close":
            newsletterBanner
              .querySelector(".newsletter-banner__content")
              .classList.add("hidden");
            newsletterBanner
              .querySelector(".newsletter-banner__above-content")
              .classList.add("hidden");
            newsletterBanner
              .querySelector(".newsletter-banner__form")
              .classList.add("hidden");
            newsletterBanner
              .querySelector(".newsletter-klaviyo__container")
              .classList.add("hidden");
            newsletterBanner
              .querySelector(".newsletter-banner__above-content")
              .remove();
            newsletterBanner.querySelector(".newsletter-banner__form").remove();
            let klaviyoCloseEvent = new CustomEvent("klaviyoClose", {
              detail: e,
            });
            newsletterBanner.dispatchEvent(klaviyoCloseEvent);
          default:
            let klaviyoUndefinedEvent = new CustomEvent(
              "klaviyoUndefinedEvent"
            );
            newsletterBanner.dispatchEvent(klaviyoUndefinedEvent);
        }
      }
    });
    this.debouncedHandleEmbedOpen = debounce((event) => {
      this.handleEmbedOpen();
    }, 400);
    this.debouncedHandleStepSubmit = debounce((event) => {
      throttle(this.handleStepSubmit(), 50);
    }, 500);
    this.debouncedHandleViewedStep = debounce((event) => {
      throttle(this.handleViewedStep(), 50);
    }, 500);
    this.debouncedHandleClose = debounce((event) => {
      throttle(this.handleClose(), 50);
    }, 300);
    this.debouncedTestForValidity = debounce((event) => {
      throttle(this.testForValidity(), 50);
    }, 100);
    this.addEventListener(
      "klaviyoEmbedOpen",
      this.debouncedHandleEmbedOpen.bind(this)
    );
    this.addEventListener(
      "klaviyoStepSubmit",
      this.handleStepSubmit.bind(this)
    );
    this.addEventListener("klaviyoSubmit", this.handleSubmit.bind(this));
    this.addEventListener(
      "klaviyoViewedStep",
      this.debouncedHandleViewedStep.bind(this)
    );
    this.addEventListener("klaviyoClose", this.debouncedHandleClose.bind(this));
    document.addEventListener("click", this.handleClick.bind(this), true);

    this.formsId = this.dataset.formsId;
    if (this.formsId !== null) {
      this.formsElement = this.querySelector(".shopify-forms-embed");
      var waitForShopifyForms = setInterval(function () {
        if (window.formStyles) {
          if (!customElements.get("app-embed")) {
            handleFormsApp();
          }
          clearInterval(waitForShopifyForms);
        }
      }, 10);
      this.formContainer.classList.remove("hidden");
    }

  }
    
  }

  handleClick(e) {
    if (
      e.target.tagName !== "undefined" &&
      this.contains(e.target) &&
      e.target.tagName == "BUTTON" &&
      !e.target.classList.contains("klaviyo-country-toggle")
    ) {
      this.querySelector(".newsletter-banner__form").classList.add("hidden");
    }
  }

  showLoadingOverlay() {
    if (this.klaviyoContainer) {
      this.klaviyoContainer.classList.add("animate-opacity");
      this.loadingOverlay.classList.remove("hidden");
    }
  }

  hideLoadingOverlay() {
    if (this.klaviyoContainer) {
      this.loadingOverlay.classList.add("hidden");
      this.klaviyoContainer.classList.remove("animate-opacity");
    }
  }

  showForm() {
    if (this.klaviyoContainer) {
      this.klaviyoContainer.classList.remove("animate-opacity");
    }
  }

  hideForm() {
    if (this.klaviyoContainer) {
      this.klaviyoContainer.classList.add("animate-opacity");
    }
  }

  resetStylesAndClasses(klaviyoForm) {
    let resetCSSElements = this.querySelectorAll(
      ".kl-private-reset-css-Xuajs1, .needsclick"
    );
    for (let i = 0; i < resetCSSElements.length; i++) {
      resetCSSElements[i].classList.remove(
        "kl-private-reset-css-Xuajs1",
        "needsclick"
      );
    }
    let inlineStyleElements = this.klaviyoForm.querySelectorAll("*[style]");
    for (let i = 0; i < inlineStyleElements.length; i++) {
      inlineStyleElements[i].style = "";
    }
  }

  addKlaviyoClasses() {
    this.klaviyoForm = this.querySelector(".klaviyo-form");
    if (this.klaviyoForm != null) {
      this.klaviyoPhoneInput =
        this.klaviyoForm.querySelector("input[type='tel']");
      if (this.klaviyoForm.querySelectorAll("a[href='[link]']")) {
        let klaviyoFormLinks =
          this.klaviyoForm.querySelectorAll("a[href='[link]']");
        klaviyoFormLinks.forEach((link, index) => {
          link.classList.add("underlined-link");
        });
      }
      if (this.klaviyoEmailInput != null) {
        this.klaviyoEmailInput.classList.add(
          "klaviyo-email-input",
          "field__input"
        );
        if (this.klaviyoEmailInput.parentElement != null) {
          this.klaviyoEmailInput.parentElement.classList.add(
            "klaviyo-email-input-parent",
            "field"
          );
          if (this.klaviyoEmailInput.parentElement.parentElement != null) {
            this.klaviyoEmailInput.parentElement.parentElement.classList.add(
              "klaviyo-email-input-grand-parent"
            );
            if (
              this.klaviyoEmailInput.parentElement.parentElement
                .parentElement != null
            ) {
              this.klaviyoEmailInput.parentElement.parentElement.parentElement.classList.add(
                "klaviyo-email-input-great-grand-parent"
              );
            }
          }
        }
      }
      if (this.klaviyoPhoneInput != null) {
        this.klaviyoForm.classList.add("klaviyo-form-step-two");
        this.klaviyoPhoneInput.classList.add(
          "field__input",
          "klaviyo-phone-input"
        );
        this.klaviyoPhoneInput.parentElement.classList.add(
          "field",
          "klaviyo-phone-input-parent"
        );
        this.klaviyoPhoneInput.parentElement.parentElement.classList.add(
          "field",
          "klaviyo-phone-input-grand-parent"
        );
        this.klaviyoPhoneInput.parentElement.parentElement.parentElement.classList.add(
          "field",
          "klaviyo-phone-input-great-grand-parent"
        );

        if (
          this.klaviyoPhoneInput.previousElementSibling.tagName === "BUTTON"
        ) {
          this.klaviyoPhoneInput.previousElementSibling.classList.add(
            "field__input",
            "klaviyo-country-toggle"
          );
        }
        this.klaviyoForm
          .querySelector(".klaviyo-country-toggle svg")
          .replaceWith(this.caretHTML);
        this.klaviyoPhoneButtons = this.klaviyoForm.querySelectorAll(
          "button:not(.klaviyo-country-toggle)"
        );
        this.klaviyoPhoneButtons.forEach((button, index) => {
          button.parentElement.classList.add("klaviyo-phone-button-parent");
          button.parentElement.parentElement.classList.add(
            "klaviyo-phone-button-grand-parent"
          );
          button.parentElement.parentElement.parentElement.classList.add(
            "klaviyo-phone-button-great-grand-parent"
          );
          button.classList.add("klaviyo-submit-button");
          for (let i = 0; i < this.klaviyoSubmitButtonClasses.length; i++) {
            button.classList.add(this.klaviyoSubmitButtonClasses[i]);
          }
        });
      }
      this.klaviyoPhoneDropdownSearch = this.klaviyoForm.querySelector(
        ".klaviyo-phone-input-great-grand-parent input[role='combobox']"
      );
      if (this.klaviyoPhoneDropdownSearch != null) {
        this.klaviyoPhoneDropdownSearch.classList.add(
          "field__input",
          "klaviyo-phone-search-input"
        );
        this.klaviyoPhoneDropdownSearch.parentElement.classList.add("field");
        this.klaviyoPhoneDropdownSearch.insertAdjacentHTML(
          "afterend",
          this.createLabel(
            "countries",
            this.klaviyoPhoneDropdownSearch.getAttribute("id")
          )
        );
        this.klaviyoPhoneDropdownContainer = this.klaviyoForm.querySelector(
          ".klaviyo-phone-input-great-grand-parent div[role='listbox']"
        );
        this.klaviyoPhoneDropdownContainer.classList.add(
          "klaviyo-phone-country-dropdown",
          "disclosure__list"
        );
        this.klaviyoPhoneDropdownContainer.parentElement.parentElement.classList.add(
          "disclosure__list-wrapper"
        );
        this.klaviyoPhoneDropdownContainer.parentElement.parentElement.parentElement.classList.add(
          "disclosure"
        );
        this.klaviyoPhoneDropdownItems =
          this.klaviyoPhoneDropdownContainer.querySelectorAll(
            "div[role='option']"
          );
        this.klaviyoPhoneDropdownItemsLinks =
          this.klaviyoPhoneDropdownContainer.querySelectorAll(
            "div[role='option'] > div > div"
          );
        for (let i = 0; i < this.klaviyoPhoneDropdownItems.length; i++) {
          this.klaviyoPhoneDropdownItems[i].classList.add("disclosure__item");
        }
        for (let i = 0; i < this.klaviyoPhoneDropdownItemsLinks.length; i++) {
          this.klaviyoPhoneDropdownItemsLinks[i].classList.add(
            "link--text",
            "disclosure__link",
            "label"
          );
        }
      }
      let klaviyoFormRowElements = this.klaviyoForm.querySelectorAll(
        "[data-testid='form-row']"
      );
      for (let i = 0; i < klaviyoFormRowElements.length; i++) {
        klaviyoFormRowElements[i].classList.add("field");
      }
      this.klaviyoErrorMessages = this.querySelectorAll(
        "input + div:empty, .klaviyo-phone-input-parent + div:empty"
      );
      for (let i = 0; i < this.klaviyoErrorMessages.length; i++) {
        this.klaviyoErrorMessages[i].classList.add("klaviyo-error-message");
      }
    }
  }

  createLabel(labelType, formElementName) {
    let label = document.createElement("label");
    let labelClass = labelType + "-label";
    label.classList.add("field__label", labelClass);
    label.innerText = this.translations[labelType];
    label.setAttribute("for", formElementName);
    return label.outerHTML;
  }

  handleEmbedOpen() {
    this.klaviyoForm = this.querySelector(".klaviyo-form");

    // Guard: if the form is already initialized, Klaviyo is re-mounting due to a
    // pushState event (facets sorting, Rivo wishlist click, etc.). Remove any
    // duplicate child containers Klaviyo appended and bail out — do not re-run
    // the full initialization which would add duplicate labels and classes.
    if (this.klaviyoForm && this.klaviyoForm.classList.contains('klaviyo-embed-initialized')) {
      const firstContainer = this.klaviyoForm.querySelector(':scope > .klaviyo-child-container');
      if (firstContainer) {
        Array.from(this.klaviyoForm.children).forEach(child => {
          if (child !== firstContainer) child.remove();
        });
      }
      return;
    }

    this.klaviyoFormElement = this.querySelector(".klaviyo-form form");
    this.klaviyoChildContainer = this.querySelector(".klaviyo-form > div");
    this.klaviyoSubmitInput = this.querySelector(
      ".klaviyo-form input[type='submit']"
    );
    this.klaviyoEmailInput = this.querySelector(
      ".klaviyo-form input[type='email']"
    );
    this.klaviyoSubmitButton = this.querySelector(".klaviyo-form button");
    this.klaviyoAllInputs = this.querySelectorAll(
      ".klaviyo-form input[type='email'], .klaviyo-form input[type='tel']"
    );
    this.klaviyoFormChildContainer = this.querySelector(
      ".klaviyo-form form > div"
    );
    this.klaviyoErrorMessages = this.querySelectorAll("input + div:empty");
    this.formButtons = this.querySelectorAll("button");

    if (this.klaviyoChildContainer != null) {
      this.klaviyoChildContainer.classList.add("klaviyo-child-container");
      this.klaviyoForm.id = "klaviyo-newsletter-embed-form";
      this.klaviyoForm.dataset.mobileLayout = this.dataset.mobileLayout;
      this.klaviyoForm.dataset.desktopLayout = this.dataset.desktopLayout;
      this.resetStylesAndClasses(this.klaviyoForm);
      this.klaviyoSubmitInput.classList.add("hidden");
      this.klaviyoEmailInput.insertAdjacentHTML(
        "afterend",
        this.createLabel("email", this.klaviyoEmailInput.getAttribute("id"))
      );

      this.klaviyoFormChildContainer.classList.add(
        "klaviyo-form-child-container"
      );
      this.klaviyoChildContainer.classList.add("klaviyo-child-container");
      this.klaviyoEmailInput.classList.add(
        "klaviyo-email-input",
        "field__input"
      );
      this.klaviyoEmailInput.setAttribute('placeholder', this.translations.email);
      this.klaviyoEmailInput.parentElement.classList.add(
        "klaviyo-email-input-parent",
        "field"
      );
      this.klaviyoEmailInput.parentElement.parentElement.classList.add(
        "klaviyo-email-input-grand-parent"
      );
      this.klaviyoEmailInput.parentElement.parentElement.parentElement.classList.add(
        "klaviyo-email-input-great-grand-parent"
      );
      this.klaviyoSubmitButton.classList.add("klaviyo-submit-button");
      this.klaviyoSubmitButton.setAttribute("disabled", true);
      let klaviyoSubmitButtonClasses =
        this.dataset.submitButtonClass.split(" ");
      for (let i = 0; i < klaviyoSubmitButtonClasses.length; i++) {
        this.klaviyoSubmitButton.classList.add(klaviyoSubmitButtonClasses[i]);
      }
      this.klaviyoSubmitButton.parentElement.classList.add(
        "klaviyo-submit-button-parent"
      );
      this.klaviyoSubmitButton.parentElement.parentElement.classList.add(
        "klaviyo-submit-button-grand-parent"
      );
      this.klaviyoSubmitButton.parentElement.parentElement.parentElement.classList.add(
        "klaviyo-submit-button-great-grand-parent"
      );
      let klaviyoFormRowElements = this.klaviyoForm.querySelectorAll(
        "[data-testid='form-row']"
      );
      for (let i = 0; i < klaviyoFormRowElements.length; i++) {
        klaviyoFormRowElements[i].classList.add("field");
      }

      this.klaviyoAllInputs.forEach((input) => {
        input.addEventListener(
          "keyup",
          this.debouncedTestForValidity.bind(this)
        );
      });
      this.klaviyoContainer.classList.remove("animate-opacity");
      this.klaviyoForm.classList.add("klaviyo-embed-initialized");

      /* Begin Mutation Observers */
      this.klaviyoMutationObserver.observe(
        this.klaviyoForm,
        this.klaviyoMutationConfig
      );
    }
  }

  testForValidity() {
    this.klaviyoFormElement = this.querySelector(".klaviyo-form form");
    this.klaviyoEmailInput = this.querySelector(
      ".klaviyo-form input[type='email']"
    );
    this.klaviyoTelephoneInput = this.querySelector(
      ".klaviyo-form input[type='tel']"
    );

    if (this.klaviyoFormElement.checkValidity()) {
      if (this.klaviyoEmailInput != null) {
        this.klaviyoFormSubmitButton = this.querySelector(
          ".klaviyo-form form button"
        );
        if (
          this.klaviyoEmailInput.getAttribute("aria-invalid") !== "true" &&
          this.klaviyoEmailInput.value.length > 0
        ) {
          this.klaviyoFormSubmitButton.removeAttribute("disabled");
        } else {
          this.klaviyoFormSubmitButton.setAttribute("disabled", true);
        }
      }
      if (this.klaviyoTelephoneInput != null) {
        this.klaviyoFormSubmitButton = this.querySelector(
          ".klaviyo-form form .klaviyo-submit-button"
        );
        if (
          this.klaviyoTelephoneInput.getAttribute("aria-invalid") !== "true" &&
          this.klaviyoTelephoneInput.value.length > 0
        ) {
          this.klaviyoFormSubmitButton.removeAttribute("disabled");
        } else {
          this.klaviyoFormSubmitButton.setAttribute("disabled", true);
        }
      }
    } else {
      if (
        this.klaviyoEmailInput != null ||
        this.klaviyoTelephoneInput != null
      ) {
        this.klaviyoFormSubmitButton = this.querySelector(
          ".klaviyo-form form button"
        );
        this.klaviyoFormSubmitButton.setAttribute("disabled", true);
      }
    }
  }

  handleViewedStep() {
    this.klaviyoMutationObserver.disconnect();
    setTimeout(() => {
      this.showForm();
      this.hideLoadingOverlay();
      this.klaviyoForm = this.querySelector(".klaviyo-form");
      if (this.klaviyoForm !== null) {
        this.klaviyoChildContainer = this.querySelector(".klaviyo-form > div");
        this.klaviyoSubmitInput = this.querySelector(
          ".klaviyo-form input[type='submit']"
        );
        this.klaviyoEmailInput = this.querySelector(
          ".klaviyo-form input[type='email']"
        );
        if (this.klaviyoEmailInput) {
          this.klaviyoEmailInput.setAttribute('placeholder', this.translations.email);
          // Watch for Klaviyo re-renders resetting the placeholder
          if (this.placeholderObserver) this.placeholderObserver.disconnect();
          const desiredPlaceholder = this.translations.email;
          this.placeholderObserver = new MutationObserver(() => {
            if (this.klaviyoEmailInput.getAttribute('placeholder') !== desiredPlaceholder) {
              this.klaviyoEmailInput.setAttribute('placeholder', desiredPlaceholder);
            }
          });
          this.placeholderObserver.observe(this.klaviyoEmailInput, { attributes: true, attributeFilter: ['placeholder'] });
        }
        this.klaviyoSubmitButton = this.querySelector(".klaviyo-form button");
        this.klaviyoFormChildContainer = this.querySelector(
          ".klaviyo-form form > div"
        );
        this.klaviyoErrorMessages = this.querySelectorAll(
          "input + div:empty, .klaviyo-phone-input-parent + div:empty"
        );
        this.klaviyoPhoneInput = this.querySelector(
          ".klaviyo-form input[type='tel']"
        );
        this.klaviyoMutationObserver.observe(
          this.klaviyoForm,
          this.klaviyoMutationConfig
        );
        if (this.klaviyoPhoneInput !== null) {
          this.klaviyoPhoneLabel = this.querySelector(".phone-label");
          this.klaviyoPhoneInput.insertAdjacentHTML(
            "afterend",
            this.createLabel("phone", this.klaviyoPhoneInput.getAttribute("id"))
          );
        }

        this.klaviyoFormElement = this.querySelector(".klaviyo-form form");
        this.resetStylesAndClasses(this.klaviyoForm);
        this.addKlaviyoClasses();
        this.klaviyoMutationObserver.observe(
          this.klaviyoForm,
          this.klaviyoMutationConfig
        );
        this.klaviyoAllInputs = this.querySelectorAll(
          ".klaviyo-form input[type='email'], .klaviyo-form input[type='tel']"
        );
        this.debouncedTestForValidity();
        this.klaviyoAllInputs.forEach((input) => {
          input.addEventListener(
            "blur",
            this.debouncedTestForValidity.bind(this)
          );
        });
        this.querySelector(".newsletter-banner__form").classList.remove(
          "hidden"
        );
      }
    }, 100);
  }

  //test this.formHasInfo within this submit
  handleStepSubmit() {
    setTimeout(() => {
      this.klaviyoFormElement = this.querySelector(".klaviyo-form form");
      this.klaviyoForm = this.querySelector(".klaviyo-embed-initialized");
      if (!this.klaviyoForm.hasChildNodes()) {
        this.querySelector(".newsletter-banner__content").classList.add(
          "hidden"
        );
        this.querySelector(".newsletter-banner__above-content").classList.add(
          "hidden"
        );
        this.querySelector(".newsletter-banner__form").classList.add("hidden");
        this.querySelector(".newsletter-klaviyo__container").classList.add(
          "hidden"
        );
        if (this.querySelector(".newsletter-banner__bottom-message") !== null) {
          this.querySelector(
            ".newsletter-banner__bottom-message"
          ).classList.add("hidden");
        }
        this.querySelector(".newsletter-banner__above-content").remove();
        this.querySelector(".newsletter-banner__form").remove();
        let klaviyoCloseEvent = new CustomEvent("klaviyoClose");
        this.dispatchEvent(klaviyoCloseEvent);
      }
    }, 300);
  }

  handleClose(event) {
    this.removeEventListener(
      "klaviyoStepSubmit",
      this.debouncedHandleStepSubmit
    );
    this.removeEventListener(
      "klaviyoViewedStep",
      this.debouncedHandleViewedStep
    );
    this.removeEventListener("klaviyoEmbedOpen", this.debouncedHandleEmbedOpen);
    this.klaviyoForm = this.querySelector(
      ".klaviyo-form.klaviyo-embed-initialized"
    );
    this.klaviyoFormElement = this.querySelector(".klaviyo-form form");
    //this.aboveContent.remove();
    //this.formContainer.remove();
    this.querySelector(".newsletter-banner__content").classList.remove(
      "hidden"
    );
    throttle(this.belowContent.classList.remove("hidden"), 50);
  }

  handleSubmit() {}

  updateNewsletterTags() {
    this.form = this.querySelector('form');
    this.tagsInput = this.form.querySelector("input[name='contact[tags]']");
    let tagsToSubmit = ["newsletter", "footer"];
    let currentCountry = this.form.querySelector(".country-select").value;
    if (currentCountry.length > 0) {
      let countryTag = `country:${currentCountry}`;
      tagsToSubmit.push(countryTag);
    }
    this.tagsInput.value = tagsToSubmit.join(", ")

  }
}

customElements.define("newsletter-banner", NewsletterBanner);

function handleFormsApp() {
  setTimeout(() => {
    let newsletterBanner = document.querySelector("newsletter-banner");
    let form = document.querySelector(
      "newsletter-banner #forms_inline_" +
        newsletterBanner.dataset.formsId +
        " > #app-embed"
    );
    for (let i = 0; i < form.shadowRoot.styleSheets.length; i++) {
      for (let j = 0; j < form.shadowRoot.styleSheets[i].cssRules.length; j++) {
        form.shadowRoot.styleSheets[i].deleteRule(j);
      }
    }

    for (let i = 0; i < form.shadowRoot.adoptedStyleSheets.length; i++) {
      for (
        let j = 0;
        j < form.shadowRoot.adoptedStyleSheets[i].cssRules.length;
        j++
      ) {
        form.shadowRoot.adoptedStyleSheets[i].deleteRule(j);
      }
    }
    let variablesCss = "";
    let typographyCss = "";
    let baseCss = "";
    let baseCssHref = "";
    let newsletterCss = "";
    let newsletterCssHref = "";
    let newsletterCustomCss = "";
    let newsletterCustomCssHref = "";
    for (let i = 0; i < document.styleSheets.length; i++) {
      if (
        document.styleSheets[i].href != null &&
        document.styleSheets[i].href.indexOf("base.css") > -1
      ) {
        baseCss = Array.from(document.styleSheets[i].cssRules)
          .map((rule) => rule.cssText)
          .join(" ");
        baseCssHref = document.styleSheets[i].href;
      }
      
      if (
        document.styleSheets[i].href != null && 
        document.styleSheets[i].href.indexOf("section-newsletter-forms-app.css") > -1 
      ) {
        newsletterCss = Array.from(document.styleSheets[i].cssRules)
          .map((rule) => rule.cssText)
          .join(" ");
        newsletterCssHref = document.styleSheets[i].href;
      }
      
      /*
      if (
        document.styleSheets[i].href != null && 
        document.styleSheets[i].href.indexOf("section-newsletter-custom.css") > -1 
      ) {
        newsletterCustomCss = Array.from(document.styleSheets[i].cssRules)
          .map((rule) => rule.cssText)
          .join(" ");
        newsletterCustomCssHref = document.styleSheets[i].href;
      }
      */
      
      if (document.styleSheets[i].title == "default-variables") {
        variablesCss = Array.from(document.styleSheets[i].cssRules)
          .map((rule) => rule.cssText)
          .join(" ")
          .replaceAll(":root", ":host");
        typographyCss = Array.from(document.styleSheets[i + 1].cssRules)
          .map((rule) => rule.cssText)
          .join(" ")
          .replaceAll(":root", ":host");
      }
    }

    form.shadowRoot.adoptedStyleSheets = [];

    let styleElement = form.shadowRoot.querySelector("style");
    styleElement.textContent =
      variablesCss +
      typographyCss +
      baseCss +
      newsletterCss +
      newsletterCustomCss + 
      ("#app-embed form {gap: " +
        document.querySelector("newsletter-banner").dataset.mobileGap +
        "} @media screen and (min-width: 768px){#app-embed form {gap: " +
        document.querySelector("newsletter-banner").dataset.desktopGap +
        "}}");

    form.shadowRoot.querySelectorAll("label").forEach((label) => {
      label.classList.add("field__label");
    });
    form.shadowRoot.querySelectorAll("input").forEach((input) => {
      input.classList.add("field__input");
    });
    form.shadowRoot
      .querySelectorAll("button[data-testid='btn-form-submit']")
      .forEach((button) => {
        let classes = document
          .querySelector("newsletter-banner")
          .dataset.submitButtonClass.split(" ");
          classes.forEach((className) => {
          button.classList.add(className);
        });
      });

    form.shadowRoot.querySelector("form").dataset.mobileLayout =
      document.querySelector("newsletter-banner").dataset.mobileLayout;
    form.shadowRoot.querySelector("form").dataset.desktopLayout =
      document.querySelector("newsletter-banner").dataset.desktopLayout;

    formMutationObserver = new MutationObserver((mutationList, observer) => {
      let successMessageMutation = mutationList.find(
        (mutation) =>
          mutation.addedNodes.length > 0 &&
          mutation.nextSibling !== null &&
          mutation.nextSibling.id == "form-container-ref" &&
          mutation.addedNodes[0].tagName.toLowerCase() == "section"
      );
      if (typeof successMessageMutation !== "undefined") {
        form.shadowRoot
          .querySelector("h2")
          .classList.add(
            document.querySelector("newsletter-banner").dataset.headingTag
          );
        document
          .querySelector("newsletter-banner .newsletter-banner__above-content")
          .classList.add("hidden");
        if (
          document.querySelector(".newsletter-banner__bottom-message") !== null
        ) {
          document
            .querySelector(
              "newsletter-banner .newsletter-banner__bottom-message"
            )
            .classList.add("hidden");
        }
      }
    });

    formMutationObserver.observe(
      form.shadowRoot.querySelector("div[data-form-root='true']"),
      {
        attributes: false,
        childList: true,
        subtree: true,
      }
    );
  }, 500);
}
